import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cargarTodosMunicipios, eliminarMunicipio, crearMunicipio, actualizarMunicipio, cargarUsuariosMunicipio } from '../../actions/adminAction';
import { esborrarErrorAction, esborrarOkAction } from '../../actions/ui';

const IconSearch  = () => <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><circle cx="11" cy="11" r="8"/><path strokeLinecap="round" d="m21 21-4.35-4.35"/></svg>;
const IconPlus    = () => <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}><path strokeLinecap="round" d="M12 5v14M5 12h14"/></svg>;
const IconEdit    = () => <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>;
const IconTrash   = () => <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>;
const IconUsers   = () => <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>;
const IconClose   = () => <svg width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M6 18L18 6M6 6l12 12"/></svg>;
const IconWarning = () => <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"/></svg>;
const IconPhoto   = () => <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/></svg>;
const IconChevL   = () => <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M15 19l-7-7 7-7"/></svg>;
const IconChevR   = () => <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" d="M9 5l7 7-7 7"/></svg>;

const PER_PAGE   = 10;
const FORM_VACIO = { Nombre_Mun:'', CP_Mun:'', Habitantes_Mun:'', PagWeb_Mun:'' };

export const GestioMunicipis = () => {
    const dispatch = useDispatch();
    const { auth } = useSelector(s => s);
    const { msgError, msgOk } = useSelector(s => s.ui);
    const municipios = useSelector(s => s.adminUsuarios?.municipios || null);

    const [busqueda,     setBusqueda]    = useState('');
    const [pagina,       setPagina]      = useState(1);
    const [modalAlta,    setModalAlta]   = useState(false);
    const [modalEditar,  setModalEditar] = useState(null);
    const [modalBorrar,  setModalBorrar] = useState(null);
    const [modalUsuaris, setModalUsuaris]= useState(null);
    const [formError,    setFormError]   = useState('');

    useEffect(() => { dispatch(cargarTodosMunicipios(auth.tokenJwt)); }, []);
    useEffect(() => {
        if (msgOk)    setTimeout(() => dispatch(esborrarOkAction()),    4000);
        if (msgError) setTimeout(() => dispatch(esborrarErrorAction()), 6000);
    }, [msgOk, msgError]);
    useEffect(() => { setPagina(1); }, [busqueda]);

    const munFiltrados = (municipios || []).filter(m =>
        m.Nombre_Mun?.toLowerCase().includes(busqueda.toLowerCase()) || m.CP_Mun?.includes(busqueda)
    );
    const totalPaginas = Math.max(1, Math.ceil(munFiltrados.length / PER_PAGE));
    const munPagina    = munFiltrados.slice((pagina-1)*PER_PAGE, pagina*PER_PAGE);

    const handleEliminar = () => {
        if (modalBorrar) { dispatch(eliminarMunicipio(auth.tokenJwt, modalBorrar.IdMunicipio)); setModalBorrar(null); }
    };

    return (
        <div>
            {/* ── Cabecera ──────────────────────────────────────────────── */}
            <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', gap:16, marginBottom:28, flexWrap:'wrap' }}>
                <div>
                    <p className="ca-label-super">Gestión</p>
                    <h2 className="ca-h2">Municipios</h2>
                    <p className="ca-subtext">{municipios ? `${municipios.length} municipios registrados` : 'Cargando...'}</p>
                </div>
                <button onClick={() => { setFormError(''); setModalAlta(true); }} className="u-btn-primary">
                    <IconPlus /> Nuevo municipio
                </button>
            </div>

            <div className="fa-alert-warning">
                ⚠️ Eliminar un municipio borrará también sus responsables (salvo admins) y todas sus evaluaciones. Acción irreversible.
            </div>

            {msgOk    && <div className="ms-alert-success">{msgOk}</div>}
            {msgError && <div className="ms-alert-error">{msgError}</div>}

            {/* ── Buscador ──────────────────────────────────────────────── */}
            <div className="ca-search-wrap" style={{ maxWidth:360, marginBottom:20 }}>
                <span className="ca-search-icon"><IconSearch /></span>
                <input
                    type="text"
                    placeholder="Buscar por nombre o CP..."
                    value={busqueda}
                    onChange={e => setBusqueda(e.target.value)}
                    className="ca-search-input"
                    style={{ width:'100%' }}
                />
            </div>

            {/* ── Grid ──────────────────────────────────────────────────── */}
            {municipios === null ? (
                <div className="u-empty-state">Cargando...</div>
            ) : munFiltrados.length === 0 ? (
                <div className="u-empty-state">No se encontraron municipios.</div>
            ) : (
                <>
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:16, marginBottom:28 }}>
                        {munPagina.map(m => (
                            <MunicipioCard key={m.IdMunicipio} municipio={m}
                                onEditar={()   => { setFormError(''); setModalEditar(m); }}
                                onUsuaris={()  => setModalUsuaris(m)}
                                onEliminar={() => setModalBorrar({ IdMunicipio: m.IdMunicipio, Nombre_Mun: m.Nombre_Mun })}
                            />
                        ))}
                    </div>
                    <Paginacion pagina={pagina} total={totalPaginas} onChange={setPagina}
                        desde={(pagina-1)*PER_PAGE+1} hasta={Math.min(pagina*PER_PAGE, munFiltrados.length)} totalItems={munFiltrados.length} />
                </>
            )}

            {/* ── Modal crear ───────────────────────────────────────────── */}
            {modalAlta && (
                <ModalFormMunicipio
                    titulo="Nuevo municipio"
                    subtitulo="Rellena los datos del nuevo municipio"
                    token={auth.tokenJwt}
                    dispatch={dispatch}
                    onClose={() => setModalAlta(false)}
                />
            )}

            {/* ── Modal editar ──────────────────────────────────────────── */}
            {modalEditar && (
                <ModalFormMunicipio
                    titulo={`Editar · ${modalEditar.Nombre_Mun}`}
                    subtitulo="Modifica los datos del municipio"
                    municipioInicial={modalEditar}
                    token={auth.tokenJwt}
                    dispatch={dispatch}
                    onClose={() => setModalEditar(null)}
                />
            )}

            {/* ── Modal usuarios ────────────────────────────────────────── */}
            {modalUsuaris && (
                <ModalUsuarisMunicipi
                    municipio={modalUsuaris}
                    token={auth.tokenJwt}
                    onClose={() => setModalUsuaris(null)}
                />
            )}

            {/* ── Modal confirmar borrado ───────────────────────────────── */}
            {modalBorrar && (
                <div className="u-modal-overlay" onClick={e => e.target===e.currentTarget && setModalBorrar(null)}>
                    <div className="u-modal-box" style={{ maxWidth:440 }}>
                        <div style={{ padding:'36px 32px', textAlign:'center' }}>
                            <div style={{ width:64, height:64, borderRadius:'50%', background:'#fef2f2', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 20px', color:'#dc2626' }}>
                                <IconWarning />
                            </div>
                            <h3 style={{ margin:'0 0 8px', fontSize:18, fontWeight:700, color:'#111827' }}>¿Eliminar municipio?</h3>
                            <p style={{ margin:'0 0 4px', fontSize:15, color:'#374151' }}><strong>{modalBorrar.Nombre_Mun}</strong></p>
                            <div className="ms-alert-error" style={{ textAlign:'left', margin:'20px 0' }}>
                                <p style={{ margin:'0 0 6px', fontSize:13, fontWeight:700 }}>Se eliminará:</p>
                                <ul style={{ margin:0, padding:'0 0 0 16px', fontSize:13, lineHeight:1.8 }}>
                                    <li>El municipio y sus datos</li>
                                    <li>Responsables <strong>no admin</strong></li>
                                    <li>Todas las evaluaciones y sus 9 categorías</li>
                                </ul>
                                <p style={{ margin:'8px 0 0', fontSize:12, fontWeight:600 }}>⚠️ Irreversible.</p>
                            </div>
                            <div style={{ display:'flex', gap:12 }}>
                                <button onClick={() => setModalBorrar(null)} className="u-btn-secondary" style={{ flex:1, justifyContent:'center' }}>Cancelar</button>
                                <button onClick={handleEliminar}             className="u-btn-danger"    style={{ flex:1, justifyContent:'center' }}>Sí, eliminar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// ══════════════════════════════════════════════════════════════════════════════
// CARD
// ══════════════════════════════════════════════════════════════════════════════
const MunicipioCard = ({ municipio: m, onEditar, onUsuaris, onEliminar }) => {
    const fotoUrl = m.Foto_Mun ? `${process.env.REACT_APP_DOMINI_UPLOAD_CIUDAD || ''}/${m.Foto_Mun}` : null;
    return (
        <div style={{ border:'1px solid #e5e7eb', borderRadius:14, overflow:'hidden', background:'#fff', display:'flex', flexDirection:'column' }}>
            {/* Foto */}
            <div style={{ height:140, background: fotoUrl ? 'transparent' : '#f3f4f6', display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden', flexShrink:0 }}>
                {fotoUrl
                    ? <img src={fotoUrl} alt={m.Nombre_Mun} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                    : <span style={{ fontSize:40 }}>🏛️</span>
                }
            </div>
            {/* Info */}
            <div style={{ padding:'14px 16px', flex:1 }}>
                <div style={{ fontWeight:700, fontSize:15, color:'#111827', marginBottom:4 }}>{m.Nombre_Mun}</div>
                <div style={{ fontSize:13, color:'#6b7280', display:'flex', flexDirection:'column', gap:3 }}>
                    {m.CP_Mun          && <span>CP {m.CP_Mun}</span>}
                    {m.Habitantes_Mun  && <span>{Number(m.Habitantes_Mun).toLocaleString('es-ES')} hab.</span>}
                    {m.PagWeb_Mun      && <a href={m.PagWeb_Mun} target="_blank" rel="noreferrer" style={{ color:'#2563eb', textDecoration:'none' }}>Ver web ↗</a>}
                </div>
            </div>
            {/* Acciones */}
            <div style={{ padding:'10px 16px', borderTop:'1px solid #f3f4f6', display:'flex', gap:6, justifyContent:'flex-end' }}>
                <button onClick={onEditar}   className="gm-btn-edit"><IconEdit />   Editar</button>
                <button onClick={onUsuaris}  className="gm-btn-users"><IconUsers /> Usuarios</button>
                <button onClick={onEliminar} className="gm-btn-delete"><IconTrash /></button>
            </div>
        </div>
    );
};

// ══════════════════════════════════════════════════════════════════════════════
// MODAL FORMULARIO MUNICIPIO
// ══════════════════════════════════════════════════════════════════════════════
const ModalFormMunicipio = ({ titulo, subtitulo, municipioInicial, token, dispatch, onClose }) => {
    const esEdicion = !!municipioInicial;
    const [form, setForm] = useState(municipioInicial
        ? { Nombre_Mun: municipioInicial.Nombre_Mun||'', CP_Mun: municipioInicial.CP_Mun||'', Habitantes_Mun: municipioInicial.Habitantes_Mun||'', PagWeb_Mun: municipioInicial.PagWeb_Mun||'' }
        : { ...FORM_VACIO }
    );
    const [foto,        setFoto]        = useState(null);
    const [fotoPreview, setFotoPreview] = useState(municipioInicial?.Foto_Mun
        ? `${process.env.REACT_APP_DOMINI_UPLOAD_CIUDAD || ''}/${municipioInicial.Foto_Mun}`
        : null
    );
    const [error,    setError]    = useState('');
    const [enviando, setEnviando] = useState(false);
    const fileRef = useRef();

    const handleFoto = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.size > 2*1024*1024) { setError('La imagen no puede superar 2 MB.'); return; }
        setFoto(file);
        const reader = new FileReader();
        reader.onload = ev => setFotoPreview(ev.target.result);
        reader.readAsDataURL(file);
    };

    const handleGuardar = async () => {
        if (!form.Nombre_Mun.trim()) { setError('El nombre del municipio es obligatorio.'); return; }
        setError(''); setEnviando(true);
        const fd = new FormData();
        Object.entries(form).forEach(([k,v]) => { if (v) fd.append(k, v); });
        if (foto) fd.append('Foto_Mun', foto);
        if (esEdicion) {
            fd.append('IdMunicipio', municipioInicial.IdMunicipio);
            dispatch(actualizarMunicipio(token, fd));
        } else {
            dispatch(crearMunicipio(token, fd));
        }
        onClose();
    };

    return (
        <div className="u-modal-overlay" onClick={e => e.target===e.currentTarget && onClose()}>
            <div className="u-modal-box" style={{ maxWidth:700
             }}>
                <div className="u-modal-header">
                    <div>
                        <h3 className="u-modal-title">{titulo}</h3>
                        <p style={{ margin:'3px 0 0', fontSize:13, color:'#6b7280' }}>{subtitulo}</p>
                    </div>
                    <button onClick={onClose} className="u-modal-close-btn"><IconClose /></button>
                </div>

                <div className="u-modal-body" style={{ overflowY:'auto', maxHeight:'65vh' }}>
                    {error && <div className="ms-alert-error" style={{ marginBottom:16 }}>{error}</div>}

                    {/* Foto */}
                    <SectionLabel icon="📷" label="Foto del municipio" />
                    <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:20 }}>
                        <div onClick={() => fileRef.current.click()}
                            style={{ width:90, height:90, borderRadius:12, border:'2px dashed #d1d5db', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', overflow:'hidden', flexShrink:0, background:'#f9fafb' }}
                            onMouseEnter={e => e.currentTarget.style.borderColor='#111827'}
                            onMouseLeave={e => e.currentTarget.style.borderColor='#d1d5db'}>
                            {fotoPreview
                                ? <img src={fotoPreview} alt="preview" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                                : <span style={{ color:'#9ca3af' }}><IconPhoto /></span>
                            }
                        </div>
                        <div>
                            <button type="button" onClick={() => fileRef.current.click()} className="u-btn-secondary" style={{ marginBottom:8 }}>
                                {fotoPreview ? 'Cambiar foto' : 'Subir foto'}
                            </button>
                            <p style={{ fontSize:12, color:'#9ca3af', margin:0 }}>JPG, PNG o WebP · Máx. 2 MB</p>
                            {fotoPreview && (
                                <button type="button" onClick={() => { setFoto(null); setFotoPreview(null); }} style={{ fontSize:12, color:'#dc2626', background:'none', border:'none', cursor:'pointer', padding:'4px 0' }}>
                                    Eliminar foto
                                </button>
                            )}
                        </div>
                        <input ref={fileRef} type="file" accept="image/*" onChange={handleFoto} style={{ display:'none' }} />
                    </div>

                    {/* Datos */}
                    <SectionLabel icon="🏛️" label="Datos del municipio" />
                    <div className="u-grid-2">
                        <Field label="Nombre municipio *" name="Nombre_Mun"     value={form.Nombre_Mun}     onChange={e => setForm({...form,[e.target.name]:e.target.value})} />
                        <Field label="Código postal"      name="CP_Mun"         value={form.CP_Mun}         onChange={e => setForm({...form,[e.target.name]:e.target.value})} />
                        <Field label="Habitantes"         name="Habitantes_Mun" value={form.Habitantes_Mun} onChange={e => setForm({...form,[e.target.name]:e.target.value})} type="number" />
                        <Field label="Página web"         name="PagWeb_Mun"     value={form.PagWeb_Mun}     onChange={e => setForm({...form,[e.target.name]:e.target.value})} type="url" />
                    </div>
                </div>

                <div className="u-modal-footer">
                    <button onClick={onClose} className="u-btn-secondary">Cancelar</button>
                    <button onClick={handleGuardar} disabled={enviando} className="u-btn-primary" style={{ opacity: enviando ? 0.7 : 1 }}>
                        {enviando ? 'Guardando...' : esEdicion ? 'Guardar cambios' : 'Crear municipio'}
                    </button>
                </div>
            </div>
        </div>
    );
};

// ══════════════════════════════════════════════════════════════════════════════
// MODAL USUARIOS DEL MUNICIPIO
// ══════════════════════════════════════════════════════════════════════════════
const ModalUsuarisMunicipi = ({ municipio, token, onClose }) => {
 const usuaris  = useSelector(s => s.adminUsuarios?.usuarisMunicipi ?? null);    const [error,   setError]   = useState('');
 const { msgError } = useSelector(s => s.ui);
    const dispatch = useDispatch();

   useEffect(() => {
        dispatch(cargarUsuariosMunicipio(token, municipio.IdMunicipio));
    }, [municipio.IdMunicipio]);

    return (
        <div className="u-modal-overlay" onClick={e => e.target===e.currentTarget && onClose()}>
            <div className="u-modal-box" style={{ maxWidth:700 }}>
                <div className="u-modal-header">
                    <div>
                        <h3 className="u-modal-title">Usuarios · {municipio.Nombre_Mun}</h3>
                        <p style={{ margin:'3px 0 0', fontSize:13, color:'#6b7280' }}>
                            {usuaris === null ? 'Cargando...' : `${usuaris.length} responsable${usuaris.length !== 1 ? 's' : ''} asignado${usuaris.length !== 1 ? 's' : ''}`}
                        </p>
                    </div>
                    <button onClick={onClose} className="u-modal-close-btn"><IconClose /></button>
                </div>

                <div className="u-modal-body" style={{ overflowY:'auto', maxHeight:'60vh' }}>
                    {error && <div className="ms-alert-error">{error}</div>}

                    {usuaris === null && !error && (
                        <div className="u-empty-state">Cargando usuarios...</div>
                    )}

                    {usuaris !== null && usuaris.length === 0 && (
                        <div className="u-empty-state">
                            <div className="u-empty-icon">👤</div>
                            Este municipio no tiene responsables asignados.
                        </div>
                    )}

                    {usuaris !== null && usuaris.length > 0 && (
                        <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                            {usuaris.map(u => (
                                <div key={u.id || u.IdResponsable} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 14px', border:'1px solid #e5e7eb', borderRadius:10, background:'#fff' }}>
                                    <div style={{ width:38, height:38, borderRadius:'50%', background:'#e5e7eb', display:'flex', alignItems:'center', justifyContent:'center', fontSize:15, fontWeight:700, color:'#4b5563', flexShrink:0 }}>
                                        {(u.Nombre_Resp || u.nombre || '?').charAt(0).toUpperCase()}
                                    </div>
                                    <div style={{ flex:1 }}>
                                        <div style={{ fontWeight:600, fontSize:14, color:'#111827' }}>
                                            {u.Nombre_Resp || u.nombre} {u.Apellidos_Resp || u.apellido}
                                        </div>
                                        <div style={{ fontSize:12, color:'#6b7280' }}>{u.Email_Resp || u.email}</div>
                                        {u.Telf_Resp||u.telf ? <div style={{ fontSize:12, color:'#9ca3af' }}>{u.Telf_Resp||u.telf}</div> : null}
                                    </div>
                                    {(u.AccesAdmin_Resp==1 || u.admin==1) && (
                                        <span className="u-badge-pink" style={{ color:'#7c3aed', background:'#ede9fe', borderColor:'#ddd6fe' }}>Admin</span>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="u-modal-footer">
                    <button onClick={onClose} className="u-btn-secondary">Cerrar</button>
                </div>
            </div>
        </div>
    );
};

// ── Componentes UI compartidos ─────────────────────────────────────────────────
const SectionLabel = ({ icon, label }) => (
    <div style={{ display:'flex', alignItems:'center', gap:8, margin:'16px 0 12px', paddingBottom:8, borderBottom:'1px solid #f3f4f6' }}>
        <span style={{ fontSize:15 }}>{icon}</span>
        <span style={{ fontSize:11, fontWeight:700, color:'#374151', textTransform:'uppercase', letterSpacing:'0.07em' }}>{label}</span>
    </div>
);

const Field = ({ label, name, value, onChange, type='text', error }) => (
    <div style={{ display:'flex', flexDirection:'column', gap:4 }}>
        <label className="u-field-label">{label}</label>
        <input type={type} name={name} value={value} onChange={onChange}
            className="u-input"
            style={{ borderColor: error ? '#f87171' : '#e5e7eb' }} />
        {error && <span style={{ fontSize:11, color:'#dc2626' }}>{error}</span>}
    </div>
);

const Paginacion = ({ pagina, total, onChange, desde, hasta, totalItems }) => {
    if (total <= 1) return null;
    const pages   = Array.from({ length:total }, (_,i) => i+1);
    const visible = pages.filter(p => p===1 || p===total || Math.abs(p-pagina)<=1);
    return (
        <div className="ca-pagination">
            <span className="ca-pag-info">Mostrando <strong>{desde}–{hasta}</strong> de <strong>{totalItems}</strong> municipios</span>
            <div className="ca-pag-btns">
                <PagBtn onClick={() => onChange(pagina-1)} disabled={pagina===1}><IconChevL /></PagBtn>
                {visible.reduce((acc,p,i,arr) => {
                    if (i>0 && arr[i-1]!==p-1) acc.push(<span key={`d${p}`} style={{ padding:'0 4px', color:'#9ca3af' }}>…</span>);
                    acc.push(<PagBtn key={p} active={p===pagina} onClick={() => onChange(p)}>{p}</PagBtn>);
                    return acc;
                }, [])}
                <PagBtn onClick={() => onChange(pagina+1)} disabled={pagina===total}><IconChevR /></PagBtn>
            </div>
        </div>
    );
};

const PagBtn = ({ children, active, disabled, onClick }) => (
    <button onClick={onClick} disabled={disabled}
        className={`ca-pag-btn${active ? ' active' : ''}`}>
        {children}
    </button>
);